export default __webpack_public_path__ + "static/media/magniss_logo.3434b837.png";